import React from 'react';
import PropTypes from 'prop-types';
import TextField from 'material-ui/TextField';
import moment from 'moment';
import globals from '../../../globals/communityGlobals';
import { grey100 } from '../../../theme/AllocateColors';
import Spinner from '../../../components/common/Spinner/Spinner';

const locale = globals.getArea('dailyPlanning');
const treatmentLocale = globals.getArea('treatments');
const styles = {
  tooltipContent: { width: '95%', backgroundColor: grey100, margin: '0 0 3% 3%' },
  h5: { marginLeft: '3%' },
  textField: { width: '95%', backgroundColor: grey100, margin: '0 0 3% 3%' },
  textFiledUnderlineDisabledStyle: { borderWidth: 0, borderColor: grey100 },
  bold: { fontWeight: 'bold' },
  italic: { fontStyle: 'italic' },
};

const defaultTimeSlots = [];
class TimelineAssignmentPopover extends React.Component {
  componentDidMount() {
    this.props.getAssignmentInfo(this.props.treatmentInstanceId);
    this.props.getHomeToVisitPostcodeDistance(this.props.treatmentInstanceId, this.props.assignmentId);
  }

  componentWillUnmount = () => {
    this.props.resetPopover();
    this.props.dismissError();
  };

  formatHour = date => moment(date).format(globals.timeFormats.short);

  sortByName = (a, b) => {
    if (a.name < b.name) {
      return -1;
    }
    if (a.name > b.name) {
      return 1;
    }
    return 0;
  };

  render() {
    const { description, timeSlots = defaultTimeSlots, treatmentInstanceId, distance, failureMessage } = this.props;

    const tooltipContent = (
      <div className="treatment-info" style={styles.tooltipContent}>
        {[
          <div key={`tooltipTreatmentInstanceHeader${treatmentInstanceId}`}>
            <span className="title-sub" style={styles.bold}>
              {locale.getMsg('treatmentSlots')}
            </span>
          </div>,
          timeSlots.sort(this.sortByName).map(({ id, from, to, name }) => (
            <div key={`tooltipTreatmentInstanceTimeSlot${treatmentInstanceId + id}`} className="info-timeslot">
              {`${name ? `${name}: ` : ''}${this.formatHour(from) + (from === to ? '' : ` - ${this.formatHour(to)}`)}`}
            </div>
          )),
        ]}
        {this.props.isFetchingDistance ? (
          <Spinner />
        ) : (
          <div>
            <br />
            <span className="title-sub" style={styles.bold}>{`${locale.getMsg('visitDistance')} `}</span>
            {failureMessage ? (
              <div style={styles.italic}>{failureMessage}</div>
            ) : (
              <span>{`${distance} ${locale.getMsg('miles')}`}</span>
            )}
          </div>
        )}
      </div>
    );

    return (
      <div>
        <h5 style={styles.h5}>{treatmentLocale.getMsg('treatmentDescription')}</h5>
        {description ? (
          <TextField
            id={`assignment${1}`}
            className="formsytext-css"
            multiLine
            rows={5}
            rowsMax={5}
            disabled
            style={styles.textField}
            underlineDisabledStyle={styles.textFiledUnderlineDisabledStyle}
            value={description}
          />
        ) : (
          <div className="treatment-info" style={styles.tooltipContent}>
            <span className="title-sub" style={styles.italic}>{`${treatmentLocale.getMsg('descriptionEmpty')} `}</span>
          </div>
        )}
        {tooltipContent}
      </div>
    );
  }
}

TimelineAssignmentPopover.defaultProps = {
  description: '',
  timeSlots: [],
  distance: '',
};

TimelineAssignmentPopover.propTypes = {
  treatmentInstanceId: PropTypes.number.isRequired,
  assignmentId: PropTypes.number.isRequired,
  failureMessage: PropTypes.string.isRequired,
  description: PropTypes.string,
  distance: PropTypes.string,
  getAssignmentInfo: PropTypes.func.isRequired,
  dismissError: PropTypes.func.isRequired,
  getHomeToVisitPostcodeDistance: PropTypes.func.isRequired,
  resetPopover: PropTypes.func.isRequired,
  isFetchingDistance: PropTypes.bool.isRequired,
  timeSlots: PropTypes.arrayOf(
    PropTypes.shape({
      from: PropTypes.string,
      to: PropTypes.string,
    }),
  ),
};

export default TimelineAssignmentPopover;
